import { el } from 'https://cdn.venturz.co/lib/redom.es.js';

import {
  applyTraits
} from '/programs/utilities/language.js';

import { CheckboxValueGetter, CheckboxValueSetter } from '../traits/value-accessors.js';

import GroupInputsRenderer from './group-inputs-renderer.js';
import Option from './option.js';

class RadioButtonGroupRenderer {

  constructor() {

    this.input = null;
    this.Option = Option;

    this.el = el('.form-editor-radio-button-group-renderer', [
      this.renderInput()
    ]);

  }

}

export default applyTraits(RadioButtonGroupRenderer, [
  CheckboxValueGetter,
  CheckboxValueSetter,
  GroupInputsRenderer
]);